const projectsData = [
    {
        name: "SearchCast",
        live: "https://searchcast.netlify.app/",
        git: "https://github.com/tpett20/SearchCast-frontend",
        image: "https://i.imgur.com/jgx0nwo.png",
        info: "An app to help you track keyword searches for Spotify podcast episodes.",
        technologies: "MERN Stack, Spotify Web API, Auth0, Bootstrap"
    },
    {
        name: "Chorderly",
        live: "https://tpett20.github.io/chorderly-game/",
        git: "https://github.com/tpett20/chorderly-game",
        image: "https://i.imgur.com/MKaqI6S.png",
        info: "A memory game designed to help you learn musical chords by ear.",
        technologies: "Javascript, HTML, CSS, DOM Manipulation"
    },
    {
        name: "StubSaver",
        live: "",
        git: "https://github.com/tpett20/StubSaver",
        image: "https://i.imgur.com/dF23Kou.png",
        info: "An app for saving the concerts and sporting events you've attended.",
        technologies: "Django, Python, PostgreSQL, Bulma"
    },
    {
        name: "Break the Ice",
        live: "",
        git: "https://github.com/tpett20/break-the-ice-app",
        image: "https://i.imgur.com/SE99KGc.png",
        info: "An app for storing icebreaker questions and responses.",
        technologies: "Express.js, Node.js, MongoDB, Mongoose, Bootstrap"
    }
]

export { projectsData }